import {CLEAR_ERROR_DESCRIPTION_EMPLOYEE_LIST} from "../../../../enums/MyDivision/EmployeeList/EmployeeListTypes";

export const clearErrDescriptionEmployeeListAction = () => {
    return {
        type: CLEAR_ERROR_DESCRIPTION_EMPLOYEE_LIST,
    };
};
